//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListSkeleton from './ListSkeleton.vue'

export default {
  components: { ListSkeleton },

  props: {
    avatar: { type: Boolean, default: false },
    title: { type: Boolean, default: false },
    items: { type: Number, default: 3 },
    button: { type: Boolean, default: false },
    buttons: { type: Boolean, default: false },
    animation: { type: String, default: "wave" },
    caption: { type: Boolean, default: false },
    itemsType: { type: String, default: null },
    itemsIcon: { type: Boolean, default: false },
  }
}
